import { InjectionToken } from '@angular/core';

import { Auth } from 'shared/constants/auth.enum';
export const ENV_CONFIG: InjectionToken<Environment> = new InjectionToken('ENV_CONFIG');
export interface Environment {
	production: boolean;
	environment: string;
	captchaV2SiteKey: string;
	captchaV3SiteKey: string;
	auth: Auth;
	keycloak?: KeycloakConfig;
}

export interface KeycloakConfig {
	url: string;
	realm: string;
	clientId: string;
}
